"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledTitle = exports.StyledSpan = exports.StyledSimpleIcon = exports.StyledIconsWrapper = exports.StyledContentAfterWrapper = exports.StyledChevronContainer = exports.StyledChevronButton = exports.StyledCheckmarkWrapper = exports.StyledCheckmarkIcon = exports.StyledAssetIconWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _button = require("../../button");
var _clickable = require("../../clickable");
var _typography = require("../../typography");
const StyledWrapper = (0, _styled.default)(_clickable.Clickable)(_ref => {
  let {
    isActive,
    isSelected,
    isParent,
    isContentLibrary
  } = _ref;
  return `
    display: flex;
    align-items: center;
    gap: 4px;
    min-height: 28px;
    min-width: 173px;
    width: 100%;
    border-radius: ${_designTokens.border.radius20};
    
    // if it's a content library, it'll appear at the very top of the root, left padding === 17px
    // if default, !isParent, left padding === 2px
    // if default, isParent, left padding === 0px
    padding: ${_designTokens.space.space10} ${_designTokens.space.space20} ${_designTokens.space.space10} ${isContentLibrary ? "17px" : isParent ? 0 : _designTokens.space.space05};
    
    box-sizing: border-box;
    background: ${isActive || isSelected ? (0, _designTokensReact.color)("color--background--neutral--weaker") : "transparent"};

    &:hover {
        background: ${(0, _designTokensReact.color)("color--background--neutral--weakest")};
    }

    &:active {
        background: ${(0, _designTokensReact.color)("color--background--neutral--weak")};
    }
`;
});
exports.StyledWrapper = StyledWrapper;
const StyledIconsWrapper = _styled.default.div`
    display: flex;
    align-items: center;
    gap: 1px;
`;
exports.StyledIconsWrapper = StyledIconsWrapper;
const StyledSimpleIcon = _styled.default.span(_ref2 => {
  let {
    color
  } = _ref2;
  return `
    width: ${_designTokens.space.space20};
    height: ${_designTokens.space.space20};
    background: ${color};
    border-radius: ${_designTokens.border.radius05};
`;
});
exports.StyledSimpleIcon = StyledSimpleIcon;
const StyledChevronContainer = _styled.default.div`
    position: absolute;
    left: -15px;
`;
exports.StyledChevronContainer = StyledChevronContainer;
const StyledChevronButton = (0, _styled.default)(_button.Button)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    max-height: 16px;
    width: 16px;
    max-width: 16px;
`;
exports.StyledChevronButton = StyledChevronButton;
const StyledAssetIconWrapper = _styled.default.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    max-height: 20px;
    width: 20px;
    max-width: 20px;
`;
exports.StyledAssetIconWrapper = StyledAssetIconWrapper;
const StyledTitle = (0, _styled.default)(_typography.TypeRampV2)`
    text-align: start;
    width: 100%;
    color: ${(0, _designTokensReact.color)("color--text--neutral--default")};
    line-height: 18px;
`;
exports.StyledTitle = StyledTitle;
const StyledSpan = (0, _styled.default)(_typography.TypeRampV2)`
    text-align: start;
    color: ${(0, _designTokensReact.color)("color--text--neutral--default")};
    margin-left: ${_designTokens.space.space10};
`;
exports.StyledSpan = StyledSpan;
const StyledCheckmarkIcon = (0, _styled.default)(_ursaIcons.CheckmarkIcon)`
    color: ${(0, _designTokensReact.color)("color--icons--primary--strong")};
`;
exports.StyledCheckmarkIcon = StyledCheckmarkIcon;
const StyledCheckmarkWrapper = _styled.default.span`
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    margin-left: ${_designTokens.space.space30}; //this value accounts for the flex gap of the container as well (4px)
`;
exports.StyledCheckmarkWrapper = StyledCheckmarkWrapper;
const StyledContentAfterWrapper = _styled.default.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
exports.StyledContentAfterWrapper = StyledContentAfterWrapper;
//# sourceMappingURL=StyledFileTreeItemComponents.js.map